import { render, staticRenderFns } from "./QuotesList.vue?vue&type=template&id=dc2615d6&scoped=true&"
import script from "./QuotesList.vue?vue&type=script&lang=js&"
export * from "./QuotesList.vue?vue&type=script&lang=js&"
import style0 from "./QuotesList.vue?vue&type=style&index=0&id=dc2615d6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc2615d6",
  null
  
)

export default component.exports